import { NgModule } from "@angular/core";
import { FileUploadModule } from "primeng/fileupload";
import { SharedModule } from "../../../shared/shared.module";
import { DataLoadRoutingModule } from "./data-load-routing.module";
import { DataLoadComponent } from "./data-load.component";
import { MemeberDataLoadSummaryComponent } from "./member-dataload-summary/member-dataload-summary.component";
import { SummaryComponent } from "./summary/summary.component";
import { DataLoadUploadComponent } from "./upload/upload.component";

@NgModule({
  imports: [
    DataLoadRoutingModule,
    SharedModule,
    FileUploadModule,
  ],
  declarations: [
    DataLoadComponent,
    DataLoadUploadComponent,
    SummaryComponent,
    MemeberDataLoadSummaryComponent,
  ],
})
export class DataLoadModule { }
